<div class="descriptionRapper">
<div class="ltms-description w-50">{{ mainDiscription }}</div>
<div class="table-widget" *ngIf="!restrictToday">
  <div class="scale-rater-wrapper" *ngIf="isAccount">
    <div class="scale-rater-text">Scale selector</div>
    <app-score-dropdown-menu [config]="{width: '120px'}" [selectedOption]="engagementService.selectedRaterType?.name" [options]="engagementService.scaleRaterType.options" (selectedOptionChange)="onOptionChange($event)"></app-score-dropdown-menu>
  </div>
  <!--Feed Search Filter Section -->
  <div class="litmus-feed-filter" id="litmusfeedsearch">
    <div class="litmus-feed-filter-input">
      <img src="assets/images/magnify.svg" alt="Search Icon">
      <div class="litmus-feed-input-field">
        <!-- Search Input Field with Two-Way Binding to searchTerm -->
        <input type="text" placeholder="Search here" [(ngModel)]="searchTerm" (input)="onSearchInput($event)" />
        <!-- Clear Search Button (Visible when searchTerm is not empty) -->
        <button *ngIf="searchTerm.trim() !== ''" class="clear-search" (click)="clearSearch()">
          <img src="assets/images/close.svg" alt="Clear Icon" />
        </button>
      </div>
    </div>
  </div>
  <!-- Widget Tools-->
  <div>
    <app-ltms-widget-tools [config]='widgetConfig'></app-ltms-widget-tools>
  </div>
  <!-- Pagination Controls -->
  <div class="litmus-details-view-paging">
    <button [disabled]="!pagingButtons.isFirst" (click)="paginateData('first')">
      <img src="assets/images/angle-double-left.svg" />
    </button>
    <button [disabled]="!pagingButtons.isPrevious" (click)="paginateData('previous')">
      <img src="assets/images/angle-left.svg" />
    </button>
    <!-- Current Page Range and Total Pages Display -->
    <span [class.disabled]="pagingDetails.total <= 0">
      {{pagingDetails.start}} - {{pagingDetails.end}} of {{pagingDetails.total}}
    </span>
    <button [disabled]="!pagingButtons.isNext" (click)="paginateData('next')">
      <img src="assets/images/angle-right.svg" />
    </button>
    <button [disabled]="!pagingButtons.isLast" (click)="paginateData('last')">
      <img src="assets/images/angle-double-right.svg" />
    </button>
  </div>
</div>
</div>
<!-- No Data Message if 'restrictToday' is True -->
<div class="parent-container">
  <!-- Message displayed when there is no data for the current date range -->
  <div *ngIf="restrictToday" class="no-data-message error-text">
    No data available for the current date range. Try changing the date range.
  </div>
  <div *ngIf="isDataLoaded == true && isDataAvailable == false && !restrictToday">
    <app-ltms-error [code]="errorCode"></app-ltms-error>
</div>
  <!-- Data Table Container (Visible when data is loaded and available and 'restrictToday' is false) -->
  <div class="ltms-engagement-table scrollable-table-fix" *ngIf="!restrictToday && isDataLoaded && isDataAvailable">
    <app-ltms-data-table-v2 [columns]="requestsJourneyHeader" [data]="tableData"
      [footerData]="tableData.length > 0 ? footerData : null" [configs]="tableConfig" footerClass="table-footer"
      [selectedFilter]="selectedOption" (onFilterChange)="getOverallSummary($event)" [errorCode]="errorCode"
      [deviationComparisonLabel]="deviationComparisonLabel" [showDeviation]="isDeviationEnabled"
      (onSort)="sortFeedList($event)">
    </app-ltms-data-table-v2>
  </div>
<!-- Loader Spinner when Data is Being Loaded -->
<div class="data-details-loader" *ngIf="!isDataLoaded" style="height: 30vh;">
  <app-ltms-loader></app-ltms-loader>
</div>